import ConsentTermContainer from './ConsentTermContainer';

export default ConsentTermContainer;
